var _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvax(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    id: "svg6",
    style: {
      fill: "none"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs10"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.1038818,
    y: 5.4753418,
    width: 19.770971,
    height: 17.981358,
    id: "rect2",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.02130493
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32,16 C 32,24.83664 24.83664,32 16,32 7.16344,32 0,24.83664 0,16 0,7.16344 7.16344,0 16,0 24.83664,0 32,7.16344 32,16 Z M 11.46606,22.36719 H 8.36091 c -0.65249,0 -0.97479,0 -1.17131,-0.1257 -0.21226,-0.13763 -0.34196,-0.36559 -0.35769,-0.6172 -0.0118,-0.2318 0.14937,-0.5149 0.47167,-1.08091 L 14.97059,7.02924 c 0.32624,-0.57387 0.49131,-0.8608 0.69963,-0.96692 0.22404,-0.11398 0.49134,-0.11398 0.71538,0 0.20832,0.10612 0.37341,0.39305 0.69963,0.96692 l 1.57618,2.7514 0.008,0.014 c 0.35237,0.61565 0.53105,0.92786 0.60907,1.25553 0.0865,0.35768 0.0865,0.73502 0,1.0927 -0.0786,0.33017 -0.25549,0.64463 -0.61318,1.26959 l -4.02729,7.1191 -0.0104,0.0182 c -0.35468,0.62072 -0.53443,0.93533 -0.78355,1.17266 -0.27121,0.2595 -0.59745,0.44805 -0.95514,0.55436 -0.32625,0.0903 -0.69177,0.0903 -1.42287,0.0903 z m 7.84153,0 h 4.44932 c 0.65641,0 0.98663,0 1.18328,-0.12953 0.21219,-0.13763 0.34578,-0.36964 0.35771,-0.62104 0.0113,-0.22434 -0.14637,-0.49641 -0.45529,-1.02952 -0.0107,-0.0181 -0.0213,-0.0366 -0.0322,-0.0554 l -2.22871,-3.81265 -0.0254,-0.0429 c -0.31318,-0.5296 -0.47127,-0.79704 -0.6743,-0.90041 -0.22392,-0.114 -0.48746,-0.114 -0.7114,0 -0.2044,0.10612 -0.36947,0.38519 -0.69571,0.94726 l -2.22078,3.81267 -0.008,0.0131 c -0.32509,0.56117 -0.48756,0.84161 -0.47584,1.0717 0.0157,0.25161 0.14543,0.48341 0.35766,0.62104 0.19262,0.1257 0.52279,0.1257 1.17919,0.1257 z",
    id: "path4",
    style: {
      clipRule: "evenodd",
      fill: "#e84142",
      fillRule: "evenodd",
      strokeWidth: 0.02130493
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvax);
export default __webpack_public_path__ + "static/media/AVAX.2f158f9e.svg";
export { ForwardRef as ReactComponent };